import { useMutation } from '@tanstack/react-query';

import { type SendSmsPayload, sendSms } from '~/services/NotificationProxyService';

export const smsQueryKeys = {
  all: ['sms'] as const,
};

export function useSendSms() {
  return useMutation({
    mutationFn: (payload: SendSmsPayload) => sendSms(payload),
  });
}
